import React from "react";
import './Footer.css';

function Footer() {
    return (
        <div>
            <div className="separator">
                <hr></hr>
            </div>

            <div className="footer-container">
                <div className="footer-text text">Consummatus in brevi, explevit tempora multa (Sab 4,13)</div>
            </div>
        </div>
    );
}

export default Footer;
